/** Label/value rows for detail panels. items: [{ label, value }] (falsy values render "—"). Long values wrap under the label on phones. */
export default function KeyValue({ items, columns = 1 }) {
  return (
    <dl className={`grid gap-x-6 gap-y-2 text-sm ${columns === 2 ? 'sm:grid-cols-2' : ''}`}>
      {items.filter(Boolean).map(({ label, value }) => (
        <div key={label} className="flex flex-wrap justify-between gap-x-4 gap-y-0.5">
          <dt className="text-muted shrink-0">{label}</dt>
          <dd className="font-medium text-right break-words min-w-0 ml-auto">{value === 0 ? 0 : value || '—'}</dd>
        </div>
      ))}
    </dl>
  );
}
